"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GlobalNavigation = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _react = _interopRequireWildcard(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactIntl = require("react-intl");
var _auth = require("../../utils/auth");
var _Navigation = _interopRequireDefault(require("../elements/Navigation"));
var _CookieBanner = _interopRequireDefault(require("./CookieBanner"));
var _UserProfile = _interopRequireDefault(require("./UserProfile"));
var _AccountEnvMenu = require("./AccountEnvMenu");
var _context, _context2, _context3;
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "container": "global_navigation-module__container___m7pGU",
  "slide": "global_navigation-module__slide___L7iqZ",
  "nav": "global_navigation-module__nav___JU1ZJ",
  "navlink": "global_navigation-module__navlink___PkCix",
  "navopen": "global_navigation-module__navopen___EMiJl global_navigation-module__nav___JU1ZJ",
  "toggle": "global_navigation-module__toggle___EXJsa",
  "close": "global_navigation-module__close___GbhXs",
  "label": "global_navigation-module__label___t_RoK",
  "wrapper": "global_navigation-module__wrapper___rZ6c6",
  "logo": "global_navigation-module__logo___byVuY",
  "usernavlink": "global_navigation-module__usernavlink___zLvMN",
  "acctenvlink": "global_navigation-module__acctenvlink___RPs2y global_navigation-module__usernavlink___zLvMN",
  "confidential": "global_navigation-module__confidential___Qu5aU",
  "confidential_acct_env": "global_navigation-module__confidential_acct_env___HqkyV global_navigation-module__confidential___Qu5aU",
  "userprofile": "global_navigation-module__userprofile___BWTxP",
  "account_env_menu": "global_navigation-module__account_env_menu___yAjIi global_navigation-module__userprofile___BWTxP",
  "icon": "global_navigation-module__icon___G0CdQ",
  "env_icon": "global_navigation-module__env_icon___tJjmE global_navigation-module__icon___G0CdQ",
  "acct_icon": "global_navigation-module__acct_icon___tPZme global_navigation-module__icon___G0CdQ",
  "labelvalue": "global_navigation-module__labelvalue___XSTjt"
};
class GlobalNavigation extends _react.Component {
  static propTypes = {
    navLinks: T.arrayOf(T.object),
    className: T.string,
    navLinkClassName: T.string,
    activeNavLinkClassName: T.string,
    logoLink: T.object,
    breadCrumbs: T.oneOfType([T.bool, T.element]),
    filterBar: T.oneOfType([T.bool, T.element]),
    children: T.oneOfType([T.array, T.element]).isRequired,
    accountId: T.string,
    accountName: T.string,
    showAccountDialog: T.func,
    onUserTokenClick: T.func,
    onUserClientClick: T.func,
    partitions: T.array,
    accounts: (0, _map.default)(_reactImmutableProptypes.default),
    confidentialClient: T.bool,
    partition: T.string,
    showMenu: T.bool
  };
  static defaultProps = {
    navLinks: [],
    breadCrumbs: false,
    filterBar: false,
    className: '',
    navLinkClassName: '',
    activeNavLinkClassName: '',
    confidentialClient: false,
    showMenu: true
  };
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }
  toggleNav = (0, _bind.default)(_context = this.toggleNav).call(_context, this);
  toggleNav() {
    if (this.state.open) {
      this.closeNav();
    } else {
      this.openNav();
    }
  }
  openNav = (0, _bind.default)(_context2 = this.openNav).call(_context2, this);
  openNav() {
    this.setState({
      open: true
    });
  }
  closeNav = (0, _bind.default)(_context3 = this.closeNav).call(_context3, this);
  closeNav() {
    this.setState({
      open: false
    });
  }
  addLinkClasses(navLinks) {
    const {
      navLinkClassName,
      activeNavLinkClassName
    } = this.props;
    const enhancedNavLinks = [];
    for (let navLink of navLinks) {
      const enhancedNavLink = {
        ...navLink
      };
      enhancedNavLinks.push(enhancedNavLink);
      if (navLink.component) continue;
      if (navLink.onClick) {
        enhancedNavLink.onClick = e => {
          this.closeNav(e);
          navLink.onClick(e);
        };
      } else {
        enhancedNavLink.onClick = this.closeNav;
      }
      enhancedNavLink.className = (0, _classnames.default)(styles.navlink, enhancedNavLink.className, navLinkClassName);
      enhancedNavLink.activeClassName = (0, _classnames.default)(enhancedNavLink.activeClassName, activeNavLinkClassName);
      if (enhancedNavLink.navLinks) {
        enhancedNavLink.navLinks = this.addLinkClasses(enhancedNavLink.navLinks);
      }
    }
    return enhancedNavLinks;
  }
  renderNav() {
    const {
      navLinks
    } = this.props;
    const {
      open
    } = this.state;

    // the wrapper that opens and moves the page should be its own component
    return /*#__PURE__*/_react.default.createElement("div", {
      className: open ? styles.navopen : styles.nav
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.toggle,
      onClick: this.toggleNav
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.close
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.label
    }, open && /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: "au.globalNavigation.close"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.wrapper
    }, /*#__PURE__*/_react.default.createElement(_Navigation.default, {
      type: "primary",
      navLinks: this.addLinkClasses(navLinks)
    })));
  }
  renderLogo() {
    const {
      logoLink
    } = this.props;
    if (logoLink) {
      return /*#__PURE__*/_react.default.cloneElement(logoLink, {
        className: styles.logo
      });
    } else {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: styles.logo
      });
    }
  }
  render() {
    const {
      breadCrumbs,
      filterBar,
      className,
      children
    } = this.props;
    const {
      open
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, className, {
        [styles.slide]: open
      })
    }, this.renderLogo(), this.renderNav(), breadCrumbs, filterBar, /*#__PURE__*/_react.default.createElement("main", {
      onClick: this.closeNav
    }, children), /*#__PURE__*/_react.default.createElement(_CookieBanner.default, null));
  }
}
exports.GlobalNavigation = GlobalNavigation;
class ConnectedGlobalNavigation extends _react.Component {
  static propTypes = {
    navLinks: T.arrayOf(T.object),
    accountId: T.string,
    accountName: T.string,
    partition: T.string,
    partitions: T.array,
    accounts: (0, _map.default)(_reactImmutableProptypes.default),
    showMenu: T.bool
  };
  static defaultProps = {
    navLinks: []
  };
  render() {
    const {
      partitions,
      confidentialClient,
      showMenu
    } = this.props;
    const canSwitchPartition = partitions && (0, _keys.default)(partitions).length > 1;
    const navLinks = [...this.props.navLinks];
    const userProfile = /*#__PURE__*/_react.default.createElement(_UserProfile.default, {
      onUserTokenClick: this.props.onUserTokenClick,
      onUserClientClick: this.props.onUserClientClick
    });
    const accountEnvMenu = /*#__PURE__*/_react.default.createElement(_AccountEnvMenu.AccountEnvMenu, {
      accountId: this.props.accountId,
      accountName: this.props.accountName,
      onPartitionChange: this.props.onPartitionChange,
      onAccountChange: this.props.onAccountChange,
      partitions: partitions,
      accounts: this.props.accounts,
      partition: this.props.partition,
      setAccountId: this.props.setAccountId,
      setPartition: this.props.setPartition
    });
    if (showMenu) {
      navLinks.push({
        labelId: canSwitchPartition ? 'au.env' : 'au.acct',
        labelValues: canSwitchPartition ? {
          env: /*#__PURE__*/_react.default.createElement("span", {
            className: styles.labelvalue
          }, this.props.partition)
        } : {
          acct: /*#__PURE__*/_react.default.createElement("span", {
            className: styles.labelvalue
          }, this.props.accountName)
        },
        labelClassName: (0, _classnames.default)(styles.acctenvlink, canSwitchPartition ? styles.env_icon : styles.acct_icon),
        navLinks: [{
          component: accountEnvMenu,
          className: styles.account_env_menu
        }],
        className: (0, _classnames.default)(styles.acctenvlink, {
          [styles.confidential_acct_env]: confidentialClient
        })
      });
    }
    if (_auth.clientContainer.client) {
      // check for running locally since devserver does not have clientContainer set
      navLinks.push({
        label: _auth.clientContainer.client && (_auth.clientContainer.client.givenName || _auth.clientContainer.client.userName),
        labelId: 'au.globalNavigation.account',
        navLinks: [{
          component: userProfile,
          className: styles.userprofile
        }],
        className: (0, _classnames.default)(styles.usernavlink, {
          [styles.confidential]: confidentialClient
        })
      });
    }
    return /*#__PURE__*/_react.default.createElement(GlobalNavigation, (0, _extends2.default)({}, this.props, {
      navLinks: navLinks
    }));
  }
}
exports.default = ConnectedGlobalNavigation;